import {
	CheckConflictAfterFeatureChangeFn,
	CheckConflictsAfterIncentiveChangeFn,
	CheckConflictsAfterModelChangeFn,
} from '~/graphql/hooks/use-configured-car-queries';
import { expect } from '~/utils/unwrap';
import {
	ChangeConfiguredCarPayloadFragment,
	CheckConflictsQuery,
	ConfiguredCarEssentialsFragment,
} from './__generated__/graphql';

export type CheckConflictResult =
	| {
			status: 'success';
			data: ConfiguredCarEssentialsFragment;
	  }
	| {
			status: 'conflict';
			conflict: NonNullable<CheckConflictsQuery['change']>;
	  }
	| {
			status: 'error';
	  };

type HandleConfigurationChangeInput =
	| {
			type: 'feature';
			variables: NonNullable<Parameters<CheckConflictAfterFeatureChangeFn>[0]>['variables'];
			checkConflict: CheckConflictAfterFeatureChangeFn;
	  }
	| {
			type: 'model';
			variables: NonNullable<Parameters<CheckConflictsAfterModelChangeFn>[0]>['variables'];
			checkConflict: CheckConflictsAfterModelChangeFn;
	  }
	| {
			type: 'incentive';
			variables: NonNullable<Parameters<CheckConflictAfterFeatureChangeFn>[0]>['variables'];
			checkConflict: CheckConflictsAfterIncentiveChangeFn;
	  };

export async function handleConfigurationChange(change: HandleConfigurationChangeInput): Promise<CheckConflictResult> {
	let changeResult: ChangeConfiguredCarPayloadFragment | undefined;

	try {
		if (change.type === 'model') {
			const result = await change.checkConflict({
				variables: change.variables,
			});

			changeResult = expect(result?.data?.change, 'checkConflict did not return a change');
		}

		if (change.type === 'feature') {
			const result = await change.checkConflict({
				variables: change.variables,
			});

			changeResult = expect(result?.data?.change, 'checkConflict did not return a change');
		}

		if (change.type === 'incentive') {
			const result = await change.checkConflict({
				variables: change.variables,
			});

			changeResult = expect(result?.data?.change, 'checkConflict did not return a change');
		}
	} catch (error) {
		console.error('checkConflict (fail)', error);
		return {
			status: 'error',
		};
	}

	if (!changeResult) {
		throw new Error('changeResult was not assigned.');
	}

	if (changeResult.conflict) {
		return {
			status: 'conflict',
			conflict: changeResult,
		};
	}

	return {
		status: 'success',
		data: expect(changeResult.configuredCar, 'expected configuredCar to be defined'),
	};
}
